module.exports = __webpack_public_path__ + "static/img/yeswecan0032.b72dfca.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/yeswecan0032.png
// module id = 598
// module chunks = 1